import React, { useEffect, useMemo, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import './style.css';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { Icon, Modal } from 'semantic-ui-react';
import 'react-minimal-datetime-range/lib/react-minimal-datetime-range.min.css'; // see if we can get rid of this
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import {
  ScheduleInterview,
  updateRoundStatus,
  setStatusOfJobApplication,
  completeAction,
  AddDeadlineForAssignment,
} from '../../../../../services/apiService';

const ERoundStatus = {
  UNSCHEDULED: 'unscheduled',
  SCHEDULED: 'scheduled',
  CLEARED: 'cleared',
  NOT_CLEARED: 'not cleared',
  DECISION_AWAITING: 'decision awaiting',
  PAUSED: 'paused',
};

function CandidateGetter(params) {
  return (
    <div className='relative flex items-center justify-center text-left top-2'>
      {!params.data && params?.node?.childrenAfterSort && (
        <p className='text-base font-extrabold'>
          {params?.node?.childrenAfterSort[0]?.data.candidate}
        </p>
      )}
      <p>{params?.data?.candidate ? `${params?.data?.candidate}` : ''}</p>
    </div>
  );
}

function CurrentRoundGetter(params) {
  const renderCurrentRound = (currentRound, data) => {
    let rejectedRound;
    data.forEach((singleRound) => {
      if (singleRound?.data?.status === ERoundStatus.NOT_CLEARED)
        rejectedRound = singleRound?.data?.roundNumber;
    });
    const _jobApplicationStatus =
      currentRound?.jobApplicationDetails?.currentStatus;
    const isRejected = _jobApplicationStatus === 'rejected';
    return (
      <div className='flex-col '>
        {!isRejected && (
          <div className='text-base font-extrabold '>
            {currentRound?.currentRoundNumber
              ? `Round ${currentRound?.currentRoundNumber}`
              : !isRejected
              ? 'Cleared All'
              : 'Rejected'}
          </div>
        )}
        {isRejected && (
          <div className='text-base font-extrabold '>
            Rejected in Round {rejectedRound}
          </div>
        )}
        {!isRejected && (
          <div className='text-xs'>{currentRound?.currentRoundDescription}</div>
        )}
      </div>
    );
  };
  return (
    <div className='relative flex items-center justify-center text-left top-2'>
      {!params.data &&
        params?.node?.childrenAfterSort &&
        renderCurrentRound(
          params?.node?.childrenAfterSort[0]?.data,
          params?.node?.childrenAfterSort
        )}
      <div className='flex-col '>
        <div className='text-sm font-semibold'>
          {params?.data?.roundNumber
            ? `Round ${params?.data?.roundNumber}`
            : ''}
        </div>
        <div className='text-xs'>
          {params?.data?.description ? `${params?.data?.description}` : ''}
        </div>
      </div>
    </div>
  );
}

function RegDateGetter(params) {
  const [showModal, setShowModal] = useState(false);
  const [startDate, setStartDate] = useState(
    params?.data?.startTime ?? new Date()
  );
  // let startDate = null;
  // let endDate = null;
  // invoke schedule interview api
  const handleInterviewSchedule = async (roundId) => {
    try {
      if (startDate && roundId) {
        let response = null;
        if (params?.data?.roundType === 'interview') {
          response = await ScheduleInterview({
            roundId: roundId,
            startTime: moment(startDate).toISOString(),
            endTime: moment(startDate).add(1, 'hours').toISOString(),
          });
        } else {
          response = await AddDeadlineForAssignment({
            roundId: roundId,
            deadline: moment(startDate).toISOString(),
          });
        }

        if (response)
          params?.onChangeHandler({ startDate, endDate: startDate });
      }
      if (params?.data?.roundType === 'interview') {
        await completeAction({
          actionType: 'add_round_timing',
          params: {
            startTime: moment(startDate).toISOString(),
            endTime: moment(startDate).add(1, 'hours').toISOString(),
          },
          roundId: roundId,
        });
      } else {
        await completeAction({
          actionType: 'add_round_timing',
          params: {
            deadline: moment(startDate).toISOString(),
          },
          roundId: roundId,
        });
      }
      // if (startDate && endDate && roundId) {
      //   const response = await ScheduleInterview({
      //     roundId: roundId,
      //     startTime: moment(startDate).toISOString(),
      //     endTime: moment(endDate).toISOString(),
      //   });
      //   if (response) params?.onChangeHandler({ startDate, endDate });
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const renderTimeCell = () => {
    if (params?.data?.status === 'unscheduled') {
      return (
        <button
          onClick={() => {
            setShowModal(true);
          }}
          className='px-3 py-1 text-base font-medium border-solid rounded bg-pastel-red text-brand-primary border-brand-primary'
        >
          <Icon name='calendar alternate outline' size='small' />
          <span className='text-xs font-semibold '> Add Time </span>
        </button>
      );
    } else {
      return (
        <div
          className='relative flex items-center text-left top-2'
          onClick={() => {
            setShowModal(true);
          }}
        >
          <div className='flex-col whitespace-normal '>
            <div
              className='text-sm font-semibold'
              style={{ whiteSpace: 'wrap' }}
            >
              <Icon name='calendar alternate outline' size='small' />
              {params?.data?.roundType === 'interview' ? (
                <span>
                  {params?.data?.startTime
                    ? `${moment(params?.data?.startTime).format(
                        'MMMM Do YYYY, h:mm a'
                      )}`
                    : ''}
                </span>
              ) : (
                <span>
                  {params?.data?.deadline
                    ? `${moment(params?.data?.deadline).format(
                        'MMMM Do YYYY, h:mm a'
                      )}`
                    : ''}
                </span>
              )}
            </div>
            {params?.data?.roundType === 'interview' && (
              <div className='text-sm'>
                {'to '}
                {moment(params?.data?.startTime).isSame(
                  params?.data?.endTime,
                  'day'
                )
                  ? `${moment(params?.data?.endTime).format('h:mm a')}`
                  : `${moment(params?.data?.endTime).format(
                      'MMMM Do YYYY, h:mm a'
                    )}`}
              </div>
            )}
          </div>
        </div>
      );
    }
  };

  const getScheduledRoundTiming = (rounds) => {
    const scheduledRounds = rounds?.filter(
      (item) => item?.data?.status === 'scheduled'
    );
    if (scheduledRounds.length === 0) {
      return null;
    }

    const roundData = scheduledRounds?.[0]?.data || {};
    return {
      time:
        roundData.roundType === 'interview'
          ? roundData.startTime
          : roundData.deadline,
      round: roundData?.roundNumber,
    };
  };

  return (
    <div
      className='relative flex items-center justify-center top-2 break-words'
      style={{ whiteSpace: 'wrap' }}
    >
      {!params.data && params?.node?.childrenAfterGroup ? (
        <>
          {getScheduledRoundTiming(params?.node?.childrenAfterGroup) && (
            <div
              className='flex flex-col break-words'
              style={{ whiteSpace: 'wrap' }}
            >
              {/* <p className='text-base font-extrabold'>
                Round{' '}
                {
                  getScheduledRoundTiming(params?.node?.childrenAfterGroup)
                    .round
                }{' '}
                scheduled at
              </p> */}
              <p
                className='text-base font-extrabold break-words'
                style={{ whiteSpace: 'wrap' }}
              >
                {moment(
                  getScheduledRoundTiming(params?.node?.childrenAfterGroup).time
                ).format('MMM Do, h:mm a')}
              </p>
            </div>
          )}
        </>
      ) : null}
      {params?.data?.status && renderTimeCell()}
      <Modal
        onClose={() => setShowModal(false)}
        onOpen={() => setShowModal(true)}
        open={showModal}
      >
        <Modal.Header>{`Schedule Round ${params?.data?.roundNumber} for ${params?.data?.candidate}`}</Modal.Header>
        <Modal.Content>
          {/* <RangePicker
            locale='en-us'
            show={true}
            disabled={false}
            placeholder={['Start Time', 'End Time']}
            defaultDates={[
              params?.data?.startTime
                ? `${
                    moment(params?.data?.startTime).format(
                      'YYYY-MM-DD,hh:mm:ss'
                    ) ?? 'YYYY-MM-DD'
                  }`
                : 'YYYY-MM-DD',
              params?.data?.startTime
                ? `${
                    moment(params?.data?.endTime).format(
                      'YYYY-MM-DD, hh:mm:ss'
                    ) ?? 'YYYY-MM-DD'
                  }`
                : 'YYYY-MM-DD',
            ]}
            initialDates={[
              params?.data?.startTime
                ? `${
                    moment(params?.data?.startTime).format(
                      'YYYY-MM-DD,hh:mm:ss'
                    ) ?? 'YYYY-MM-DD'
                  }`
                : 'YYYY-MM-DD',
              params?.data?.startTime
                ? `${
                    moment(params?.data?.endTime).format(
                      'YYYY-MM-DD, hh:mm:ss'
                    ) ?? 'YYYY-MM-DD'
                  }`
                : 'YYYY-MM-DD',
            ]} // ['YYYY-MM-DD', 'YYYY-MM-DD']
            onConfirm={(res) => handleDateChange(res)}
            onClose={() => console.log('onClose')}
            onClear={() => clearDates()}
            style={{ width: '600px', margin: '0 auto' }}
          /> */}
          <div className='flex flex-col justify-center p-5 border w-70'>
            <DatePicker
              selected={new Date(startDate)}
              showTimeSelect
              dateFormat='dd/MM/yyyy, h:mm aa'
              onChange={(date) => setStartDate(date)}
              style={{ width: '100%' }}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <button
            onClick={() => {
              setShowModal(false);
            }}
            className='px-8 py-2 ml-8 text-base font-medium border rounded text-gray border-primary-400'
          >
            Cancel
          </button>
          <button
            onClick={() => {
              setShowModal(false);
              handleInterviewSchedule(params?.data?.roundId);
            }}
            className='px-8 py-2 ml-8 text-base font-medium text-white border rounded bg-brand-primary border-primary-400'
          >
            Schedule
          </button>
        </Modal.Actions>
      </Modal>
    </div>
  );
}

function StatusGetter(params) {
  // const [status, setStatus] = useState(params?.data?.status);
  const statusOptions = [
    {
      key: 'unscheduled',
      text: 'Unscheduled',
      value: 'unscheduled',
      disabled: true,
    },
    {
      key: 'scheduled',
      text: 'Scheduled',
      value: 'scheduled',
      disabled: true,
    },
    {
      key: 'cleared',
      text: 'Cleared',
      value: 'cleared',
    },
    {
      key: 'not cleared',
      text: 'Not Cleared',
      value: 'not cleared',
    },
    {
      key: 'decision awaiting',
      text: 'Decision awaiting',
      value: 'decision awaiting',
    },
    {
      key: 'paused',
      text: 'Paused',
      value: 'paused',
    },
  ];

  const status = params?.data?.status;

  // call update status with status and roundId
  const handleStatusChange = async (status) => {
    try {
      const response = await updateRoundStatus({
        status,
        roundId: params?.data?.roundId,
      });
      await completeAction({
        actionType: 'update_round_decision',
        roundId: params?.data?.roundId,
      });
      params?.onChangeHandler();
      console.log('updating status response::', response);
    } catch (error) {
      console.log('error in updating status::', error);
    }
  };

  const renderJobApplicationStatus = (status) => {
    const JA_STATUS = {
      IN_PROGRESS: 'in progress',
      COMPLETED: 'completed',
      OFFER_MADE: 'offer made',
      REJECTED: 'rejected',
      PAUSED: 'paused',
    };

    switch (status) {
      case JA_STATUS.IN_PROGRESS:
        return <p className='text-base font-extrabold '>In progress</p>;
      case JA_STATUS.COMPLETED:
        return <p className='text-base font-extrabold '>Completed</p>;
      case JA_STATUS.PAUSED:
        return <p className='text-base font-extrabold '>Paused</p>;
      case JA_STATUS.OFFER_MADE:
        return <p className='text-base font-extrabold '>Offer made</p>;
      case JA_STATUS.REJECTED:
        return <p className='text-base font-extrabold '>Rejected</p>;
      default:
        return <p className='text-base font-extrabold '>In progress</p>;
    }
  };

  const isStatusItemDisabled = (item) => {
    if (
      item?.text?.toUpperCase() === ERoundStatus?.UNSCHEDULED?.toUpperCase()
    ) {
      if (
        params?.data?.status === ERoundStatus?.NOT_CLEARED ||
        params?.data?.status === ERoundStatus?.CLEARED
      ) {
        return true;
      }
    } else {
      return item?.disabled ?? false;
    }
  };

  return (
    <div className='relative flex items-center justify-center top-2'>
      <div style={{ position: 'relative' }}>
        {!params.data &&
          renderJobApplicationStatus(
            params?.node.allLeafChildren[0]?.data?.jobApplicationDetails
              ?.currentStatus
          )}
        {params?.data?.roundNumber && (
          <select
            value={status}
            onChange={(e) => {
              console.log('change status', e.target.value);
              handleStatusChange(e.target.value);
            }}
          >
            {statusOptions.map((item) => (
              <option
                key={item.key}
                value={item.value}
                disabled={isStatusItemDisabled(item)}
              >
                {' '}
                {item.text}{' '}
              </option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
}

export const ExpandableTable = ({
  data = [],
  onChangeHandler,
  getSelectedJobApplications,
}) => {
  const [rowData, setRowData] = useState(data);
  const columnDefs = [
    {
      field: 'candidateEmail',
      headerName: 'Candidate Email',
      rowGroup: true,
      hide: true,
    },
    {
      field: 'candidate',
      headerName: 'Name',
      cellRenderer: CandidateGetter,
    },
    {
      field: 'currentRound',
      headerName: 'Current Round',
      cellRenderer: CurrentRoundGetter,
    },
    {
      field: 'schedule',
      headerName: 'Schedule',
      cellRenderer: RegDateGetter,
      cellRendererParams: {
        onChangeHandler: onChangeHandler,
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      cellRenderer: 'statusRenderer',
      cellRendererParams: {
        onChangeHandler: onChangeHandler,
      },
    },
    {
      headerName: 'Actions',
      field: 'actions',
      cellRenderer: 'btnCellRenderer',
      cellRendererParams: {
        onChangeHandler: onChangeHandler,
        getJobApplicationData: (params) => {
          console.log('params render params::', params);
          return 'test';
        },
      },
      width: 30,
      sortable: false,
      suppressMenu: true,
    },
  ];
  useEffect(() => {
    setRowData(data);
  }, [data]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      padding: 10,
      minWidth: 100,
      sortable: true,
      resizable: true,
    };
  }, []);
  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      headerName: 'Candidate',
      filter: 'agTextColumnFilter',
      headerCheckboxSelection: true,
      cellRendererParams: {
        checkbox: true,
        suppressCount: true,
        innerRenderer: 'fileCellRenderer',
      },
    };
  }, []);

  const ButtonRenderer = (params) => {
    const [anchor, setAnchor] = useState(null);

    const updateOfferMadeOnJobApplication = async (
      jobApplicationId,
      _status
    ) => {
      try {
        const response = await setStatusOfJobApplication({
          jobApplicationId: jobApplicationId,
          status: _status,
        });
        console.log('response::', response);
        params?.onChangeHandler(params);
      } catch (error) {
        console.log('error in updating status::', error);
      }
    };
    const actionOptions = [
      {
        key: 'offermade',
        text: 'Offer made',
        value: 'offer made',
      },
      {
        key: 'paused',
        text: 'paused',
        value: 'paused',
      },
    ];
    const handleActionChange = async (action) => {
      try {
        if (action.value === 'offer made') {
          updateOfferMadeOnJobApplication(
            params?.node.allLeafChildren[0]?.data?.jobApplicationId,
            'offer made'
          );
        }
        if (action.value === 'paused') {
          updateOfferMadeOnJobApplication(
            params?.node.allLeafChildren[0]?.data?.jobApplicationId,
            'paused'
          );
        }
      } catch (error) {
        console.log('error in updating Job application status::', error);
      }
    };

    return (
      <div>
        {!params.data ? (
          <div>
            <Button
              onClick={(e) => setAnchor(e.currentTarget)}
              aria-controls='actions-menu'
              aria-haspopup='true'
              className='opacity-60'
            >
              <MoreVert />
            </Button>
            <Menu
              id='simple-menu'
              anchorEl={anchor}
              open={Boolean(anchor)}
              onClose={() => setAnchor(null)}
              keepMounted
            >
              {actionOptions.map((action) => (
                <MenuItem
                  onClick={() => handleActionChange(action)}
                  value={action.value}
                  key={action.value}
                >
                  {action.text}
                </MenuItem>
              ))}
            </Menu>
          </div>
        ) : null}
      </div>
    );
  };

  const frameworkComponents = {
    btnCellRenderer: ButtonRenderer,
    statusRenderer: StatusGetter,
  };

  const rowStyle = { background: 'white' };

  const getRowStyle = (params) => {
    if (!params?.node?.data) {
      return {
        background: 'white',
        borderBottom: '1px solid #e6e6e6',
        fontSize: '14px',
        color: '#5E6E88',
      };
    } else if (
      params?.node?.data?.currentRoundNumber === params?.node?.data?.roundNumber
    ) {
      return {
        background: '#FDF8F1',
        borderBottom: '1px solid #e6e6e6',
        fontSize: '14px',
        color: '#5E6E88',
      };
    } else {
      return {
        background: '#F5F7FA',
        borderBottom: '1px solid #e6e6e6',
        fontSize: '14px',
        color: '#5E6E88',
      };
    }
  };

  const CustomLoadingOverlay = (props) => {
    return (
      <div className='ag-overlay-loading-center'>
        <i className='fas fa-hourglass-half'> {props.loadingMessage} </i>
      </div>
    );
  };

  const loadingOverlayComponentParams = useMemo(() => {
    return {
      loadingMessage: 'One moment please...',
    };
  }, []);

  return (
    <div
      style={{ height: '60vh', width: '100%' }}
      className='mt-8 ag-theme-balham'
    >
      <AgGridReact
        rowData={rowData}
        rowSelection='multiple'
        suppressRowClickSelection={true}
        rowStyle={rowStyle}
        rowHeight={50}
        getRowStyle={getRowStyle}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        autoGroupColumnDef={autoGroupColumnDef}
        loadingOverlayComponent={CustomLoadingOverlay}
        loadingOverlayComponentParams={loadingOverlayComponentParams}
        groupDefaultExpanded={false}
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
          if (!rowData || rowData.length === 0) {
            params.api.showLoadingOverlay();
          }
        }}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
        frameworkComponents={frameworkComponents}
        onSelectionChanged={(params) => {
          const filteredSelections = params.api
            .getSelectedNodes()
            .filter((node) => {
              return node.rowIndex !== null;
            });

          if (filteredSelections) {
            getSelectedJobApplications(
              filteredSelections.map(
                (node) => node?.childrenAfterSort[0]?.data?.jobApplicationId
              ),
              filteredSelections.map((node) => node?.childrenAfterSort)
            );
          }
        }}
      />
    </div>
  );
};
